import { ACTION_AUTHEN_TOKEN_EXPIRE, ACTION_AUTHEN_VERIFY_OTP, ACTION_AUTHEN_VERIFY_OTP_ERROR, ACTION_AUTHEN_VERIFY_OTP_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    access_token: undefined,
}

export const verifyOTPReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_AUTHEN_VERIFY_OTP:
            return { ...state, isLoading: true, erro_msg: undefined };
        case ACTION_AUTHEN_VERIFY_OTP_SUCCESS:
            console.log(action.payload)
            let token = {}
            token[action.payload.access_token.app.gate + "_" + action.payload.access_token.app.appid] = action.payload.access_token.token
            return { ...state, isLoading: false, erro_msg: undefined, access_token: token };
        case ACTION_AUTHEN_VERIFY_OTP_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        case ACTION_AUTHEN_TOKEN_EXPIRE:
            return { ...state, ...initState }
        default:
            return state;
    }
}